import { render, staticRenderFns } from "./SdsTableSection9BoilingPoint.vue?vue&type=template&id=24eaf550&scoped=true"
import script from "./SdsTableSection9BoilingPoint.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsTableSection9BoilingPoint.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SdsTableSection9BoilingPoint.vue?vue&type=style&index=0&id=24eaf550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24eaf550",
  null
  
)

export default component.exports